import * as z from "zod/v4";

export const ShopperAgentIMessageConfigSchema = z.object({
  enabled: z.boolean().optional(),
});

export type ShopperAgentIMessageConfig = z.infer<
  typeof ShopperAgentIMessageConfigSchema
>;
